<script setup lang="ts">
import BaseModal from './BaseModal.vue';
import { useModalStore } from '@/features/modals/modalStore'

const modalStore = useModalStore();

</script>

<template>
  <BaseModal :is-open="true" :title="modalStore.modal.props.title ?? 'Загрузка'" :forced-to-be-open="true">
    <div class="loader-body">
      <div class="loader"></div>
      {{ modalStore.modal.props.text ?? "Загрузка..." }}
    </div>
  </BaseModal>
</template>
